import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import moment from 'moment/moment';
import { Input, DateCalendarForm, CreateChancel, SelectAutocompleteMultiple } from 'components';
import { httpRequestsOnErrorsActions, formActions } from 'store';
import { FindLoad, renderDate, useModal } from 'utils';
import { formBuilderStatusEnums, formModelEnums } from 'pages';

const FORM_ACTION_TYPE = 'GET_FORMS';

export const CreateProgressReport = ({ info }) => {
    const ACTION_TYPE = info ? 'EDIT_PROGRESS_REPORT' : 'CREATE_PROGRESS_REPORT';
    const client = useSelector((state) => state.client.clientItemInfo);
    const forms = useSelector((state) => state.forms.forms);
    const dispatch = useDispatch();
    const loader = FindLoad(ACTION_TYPE);
    const { close } = useModal();
    const {
        handleSubmit,
        watch,
        control,
        clearErrors,
        setValue,
        setError,
        formState: { errors },
    } = useForm();
    const navigate = useNavigate();
    const currentForm = forms?.data?.find((form) => form?.id === watch('customForm'));

    useEffect(() => {
        dispatch(formActions.getForms({ model: formModelEnums.PROGRESSREPORT, status: formBuilderStatusEnums.PUBLISHED }));

        return () => {
            clearErrors();
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        };
    }, []);
    const handleCreate = (data) => {
        close();
        navigate(`/progress-report/${watch('customForm')}/client/${client?.id}`, {
            state: {
                reportTitle: data.reportTitle,
                startDate: data.startDate,
                endDate: data.endDate,
            },
        });
    };

    useEffect(() => {
        if (watch('customForm') && !watch('reportTitle')) {
            setValue('reportTitle', `${currentForm?.title} ${client?.code ? ` - ${client.code}` : ''} `);
        }
    }, [watch('customForm')]);

    return (
        <div style={{ width: 710 }}>
            <p className="modal-header-title">{info ? 'Edit Report' : 'Create Report'}</p>

            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-body-wrapper">
                    <SelectAutocompleteMultiple
                        defaultSelected={
                            info?.template && {
                                title: info?.template?.title,
                                name: info?.template?.title,
                                id: info?.template?.id,
                                value: info?.template?.title,
                            }
                        }
                        loadType={FORM_ACTION_TYPE}
                        name={`customForm`}
                        placeholder={'Select Template'}
                        label={'Template*'}
                        control={control}
                        options={forms?.data}
                        rules={{ required: 'Template is required.' }}
                        renderValue={(option) => `${option?.title} ${option?.description ? `- ${option?.description}` : ''}`}
                    />

                    <div className="flex-align-center" style={{ gap: 12 }}>
                        <DateCalendarForm
                            handleChange={(date) => {
                                setValue('startDate', date);
                                const endDate = watch('endDate');
                                if (endDate && moment.utc(endDate).isAfter(moment.utc(date).add(13, 'months'))) {
                                    setValue('endDate', '');
                                }
                            }}
                            name="startDate"
                            label="Start Date*"
                            min={watch('endDate') ? moment.utc(watch('endDate')).subtract(13, 'months').format('YYYY-MM-DD') : ''}
                            max={watch('endDate') ? moment.utc(watch('endDate')).format('YYYY-MM-DD') : ''}
                            control={control}
                            rules={{ required: 'Start date is required.' }}
                        />
                        <DateCalendarForm
                            handleChange={(date) => {
                                setValue('endDate', date);
                                const startDate = watch('startDate');
                                if (startDate && moment.utc(date).isAfter(moment.utc(startDate).add(13, 'months'))) {
                                    setValue('endDate', '');
                                }
                            }}
                            name="endDate"
                            label="End Date*"
                            min={watch('startDate') ? moment.utc(watch('startDate')).format('YYYY-MM-DD') : ''}
                            max={watch('startDate') ? moment.utc(watch('startDate')).add(13, 'months').format('YYYY-MM-DD') : ''}
                            control={control}
                            rules={{ required: 'End date is required.' }}
                        />
                    </div>

                    <Input
                        disabled={!watch('customForm')}
                        name="reportTitle"
                        label="Report Name*"
                        variant="outlined"
                        control={control}
                        maxLength={100}
                        rules={{
                            maxLength: {
                                value: 100,
                                message: 'Max length is 100 digits.',
                            },
                            required: 'Report name is required.',
                        }}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={'Create Report'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                    cancelRight={'16px'}
                />
            </form>
        </div>
    );
};
